import React from 'react';

/**
 * Bannière hero espace client V2 (image mockup + overlay sombre).
 */
const ClientPortalHero = ({
  image,
  kicker,
  title,
  subtitle,
  action,
  testId = 'client-portal-hero',
}) => (
  <section
    className="client-v2-hero relative overflow-hidden rounded-2xl border border-white/10 mb-6"
    data-testid={testId}
  >
    <div
      className="absolute inset-0 bg-cover bg-center scale-105"
      style={{ backgroundImage: `url(${image})` }}
      aria-hidden="true"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0f1117]/95 via-[#0f1117]/70 to-transparent" aria-hidden="true" />
    <div className="relative z-10 p-5 sm:p-8 min-h-[160px] sm:min-h-[200px] flex flex-col justify-center">
      {kicker && (
        <p className="text-[11px] sm:text-xs font-bold uppercase tracking-widest text-red-400 mb-1">{kicker}</p>
      )}
      <h1 className="text-xl sm:text-2xl font-black text-white leading-tight max-w-xl">{title}</h1>
      {subtitle && (
        <p className="text-sm text-gray-400 mt-2 max-w-lg">{subtitle}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  </section>
);

export default ClientPortalHero;
